<template>
  <v-container fluid>
    <p class="tab-title display-2 text-center justify-center py-6">Help</p>
    <v-tabs v-model="tab" vertical>
      <v-tab v-for="item in menu" :key="item.title">{{ item.title }}</v-tab>
      <v-tab>API Documentation</v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in menu" :key="item.title">
          <v-card flat>
            <v-card-title>{{ item.title }}</v-card-title>
            <v-card-text>
              {{ item.main }}
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title>API Documentation</v-card-title>
            <v-card-text>
              <p>
                The Veriscan API provides both Swagger and Redoc documentation and specifications. 
                See the documentation links below.
                <ul>
                  <li><a target="_black" href="/swagger-ui/index.html">Veriscan API Swagger</a></li>
                  <li><a target="_black" href="/apidoc.html">Redoc</a></li>
                </ul>
              </p>
              <h3>Authentication</h3>
              <p>
                API authentication requires valid user credentials which can be setup in the Users Setting page. 
                Auth requests should be sent via POST to the /authenticate service which provides an access token
                that can be used with subsequnt API requests. 
                <br>
                The API user must have appropriate permissions setup for the actions you intend to perform via API. 
              </p>

            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>
export default {
  name: "Help",
  methods: {},
  props: {},
  created() {},
  data() {
    return {
      tab: null,
      menu: [
        {
          title: "Overview",
          main: this.$t("content.help.overview.main"),
          header: this.$t("content.help.overview.header"),
        },
        {
          title: "How the search works",
          main: this.$t("content.help.overview.main"),
          header: this.$t("content.help.overview.header"),
        },
        {
          title: "Search parameters",
          main: this.$t("content.help.overview.main"),
          header: this.$t("content.help.overview.header"),
        },
      ],
    };
  },
};
</script>

<style scoped>
#keep .v-navigation-drawer__border {
  display: none;
}
.tab-title {
  font-weight: 500;
  color: #414141;
}
</style>